/**
 * src/components/ui/FullPageLoader.tsx
 * =============================================================================
 * Splash minimal para transiciones entre rutas y cargas iniciales de sesión.
 * Sin spinner agresivo — un pulse sutil en línea con la estética Linear/Notion.
 * =============================================================================
 */

import { useTranslation } from 'react-i18next'

export function FullPageLoader() {
  const { t } = useTranslation()
  return (
    <div className="min-h-dvh flex items-center justify-center bg-background">
      <div
        role="status"
        aria-label={t('actions.loading')}
        className="h-8 w-8 rounded-full border border-border border-t-foreground animate-spin"
      />
    </div>
  )
}
